import { ar } from '../locales/ar-AR';
import { en } from '../locales/en-EN';
import { ru } from '../locales/ru-RU';
import { zh } from '../locales/zh-CN';

const locales = {
  ru,
  en,
  zh,
  ar,
};

export const getLocaleData = (locale?: string) => {
  const currentLocale = locale || 'ru';
  return locales[currentLocale as keyof typeof locales] || locales.ru;
};

type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & {
  other: string;
};

const bonusPlurals: Record<string, PluralForms> = {
  ru: {
    one: 'бонус',
    few: 'бонуса',
    many: 'бонусов',
    other: 'бонуса',
  },
};

// Возвращает форму слова «бонус» по правилам Intl.PluralRules
// или undefined, если для локали формы не заданы
export const getBonusWord = (count: number, locale?: string) => {
  const forms = bonusPlurals[locale || 'ru'];

  if (!forms) {
    return undefined;
  }

  const rule = new Intl.PluralRules(locale || 'ru').select(Math.abs(count));
  return forms[rule] ?? forms.other;
};

const monthKeys = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
] as const;

const ruMonthGenitive: Record<string, string> = {
  january: 'января',
  february: 'февраля',
  march: 'марта',
  april: 'апреля',
  may: 'мая',
  june: 'июня',
  july: 'июля',
  august: 'августа',
  september: 'сентября',
  october: 'октября',
  november: 'ноября',
  december: 'декабря',
};

export const getMonthNames = (locale?: string) => {
  const currentLocale = locale || 'ru';

  if (currentLocale === 'ru') {
    return monthKeys.map((key) => ruMonthGenitive[key]);
  }

  const localeData = getLocaleData(locale);
  return monthKeys.map((key) => localeData[key].toLowerCase());
};

export const getMonthNamesNominative = (locale?: string) => {
  const localeData = getLocaleData(locale);
  return monthKeys.map((key) => localeData[key]);
};
